import Skeleton, { SkeletonShape } from './Skeleton';
import './Skeleton.scss';

export { SkeletonShape };
export default Skeleton;
